(function()
{
    // Import class
    var BaseState = include('springroll.easeljs.BaseState');

    /**
     *  The logic for the title state
     *  @class sid.TitleState
     *  @extends springroll.easeljs.BaseState
     */
    var TitleState = function(options)
    {
        BaseState.call(this, new sid.TitlePanel(), options);
        onPlay = onPlay.bind(this);
    };

    // Super prototype
    var s = BaseState.prototype;

    // Extend the base class
    var p = extend(TitleState, BaseState);

    var exiting = false;

    /**
     *  When the transition is done playing and we're fully in
     */
    p.enterDone = function()
    {
        this.panel.playButton.on("click", onPlay);
        this.panel.background.on("click", onPlay);
        this.panel.background.cursor = "pointer";
    };

    /**
     *  Handler when the play button is clicked
     */
    var onPlay = function()
    {
        //Don't play music while in dev mode, only as
        //a courtesy to the developer
        if(exiting) return;
        
        if (RELEASE)
        {
            this.game.music = 'E2_BG_MUSIC';
        }
        this.panel.background.off("click", onPlay);
        this.panel.playButton.off("click", onPlay);
        this.nextState();

        exiting = true;
    };

    /**
     *  When the state exists
     */
    p.exit = function()
    {
        if (!this.assetsLoaded) return;

        this.panel.background.cursor = null;
        this.panel.background.off("click", onPlay);
        this.panel.playButton.off("click", onPlay);

        s.exit.call(this);
    };

    //Assign to namespace
    namespace("sid").TitleState = TitleState;
}());
